export default __webpack_public_path__ + "static/media/notification-pin.49b9899d.svg";